import React from 'react';
import { useDispatch } from 'react-redux';
import { getEtsyLoginUrl } from 'actions/etsy';
import Button from 'components/Button';
import Dialog from '@material-ui/core/Dialog';
import { ModalContainer, Footer } from 'styles/pages/my-stores/registration';

const getUrlParameter = (url, parameter) => {
  parameter = parameter.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?|&]' + parameter.toLowerCase() + '=([^&#]*)');
  var results = regex.exec('?' + url.toLowerCase().split('?')[1]);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const getParameterByName = (name, url) => {
  const decodeLoginUrl = decodeURIComponent(
    url.slice(url.indexOf('=') + 1, url.length)
  );
  return getUrlParameter(decodeLoginUrl, name);
};

const EtsyModal = ({ modal, setModal, showVerifierModal }) => {
  const dispatch = useDispatch();

  return (
    <Dialog maxWidth='md' open={modal} onClose={() => setModal(false)}>
      <ModalContainer>
        <h1>Authorize Your Etsy Account</h1>
        <p>
          The term 'Etsy' is a trademark of Etsy, Inc. This application uses the
          Etsy API but is not endorsed or certified by Etsy, Inc.
        </p>
        <Footer>
          <Button variant='text' title='Back' />
          <Button
            variant='text'
            title='Continue'
            onClick={async () => {
              const request = await dispatch(getEtsyLoginUrl());

              if (request?.error) {
                return;
              }

              const oauthToken = getParameterByName('oauth_token', request);
              const accessTokenSecret = getParameterByName(
                'oauth_token_secret',
                request
              );
              const url = decodeURIComponent(request.split('login_url=')[1]);

              if (!url) {
                setModal(false);
                return;
              }

              window.open(url);
              showVerifierModal({
                oauthToken,
                accessTokenSecret,
              });
            }}
          />
        </Footer>
      </ModalContainer>
    </Dialog>
  );
};

export default EtsyModal;
